const $$splitComponentImporter = () => import('/Users/xpress/Code/knrt/jgxt/projects/jgxt/ui/web/src/routes/console/_auth/_layout/dashboard.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { type DashboardCare, type DashboardCareFollowUp, type DashboardManagement, type DashboardOverview, type DashboardSourceDistribution } from '@/api/dashboard';
export const Route = createFileRoute('/console/_auth/_layout/dashboard')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});

// region 类型与语义色映射
type Tone = 'primary' | 'blue' | 'orange' | 'red' | 'purple' | 'text' | 'muted';
type Metric = {
  title: string;
  tip?: string; // 口径说明, 悬停标题旁的问号显示
  value: string;
  suffix?: string;
  trend?: string;
  valueTone?: Tone;
  trendTone?: Tone;
};

// 底色统计格(复查提醒 / 患者随访卡)与纯文字统计格(AI 统计卡)
type SoftStatCell = {
  label: string;
  value: string;
  tone: Exclude<Tone, 'text' | 'muted'>;
};
type TextStatCell = {
  label: string;
  value: string;
  tone: Tone;
};
type Todo = {
  id: string;
  name: string;
  badge?: string;
  badgeTone?: Tone;
  desc: string;
  time: string;
};

// 旧十六进制色改 HeroUI 语义 token:primary→success、blue/purple→accent、orange→warning、red→danger
// AI 巡查风险等级 → 徽章文案与色调
// 随访状态 → 徽章文案与色调, 已取消的不会出现在首页
// 复查提醒与随访卡片的统计范围说明
// 用户来源分类与条形配色, 顺序即展示顺序; 平台是「无院内记录」的兜底类, 用中性灰
// 各指标的口径说明, 集中放一处便于核对
// endregion
// 管理视角: 超管额外看到管理归属、覆盖、活跃趋势与功能使用; 健管师 / 运营员只看基础概览
// 超管的核心指标: 用真实的活跃与新增替代原先写死的两项 100%
// region 复查提醒与患者随访
// 管理视角和医生工作台共用, 统计范围由服务端按角色决定, 卡片描述里写明
// 上面一排底色统计格, 下面是近 7 天的明细列表
// endregion
// 用户来源分布: 横向条形, 全为 0(含数据未就绪)时按无数据占位
// 指标行:仿模板 KPI 行;纯数字走 KPI.Value,带 % 等符号的直接文本渲染
// endregion
if (import.meta.hot) {
  import.meta.hot.accept(newModule => {
    if (newModule && newModule.Route && typeof newModule.Route.clone === 'function') {
      newModule.Route.clone(Route);
    }
  });
}